import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from "@angular/core";
import { FetchDataService } from "Services/fetch-data.service";
import { EventService } from "Services/event.service";
import { ModalConfig } from "Classes/ModalConfig";
import { User } from "Classes/User";
declare var $: any;

@Component({
    selector: "create-user",
    template: require('./create-user.component.html'),
    styles: [require('./create-user.component.css')]
})

export class CreateUserComponent implements OnInit, AfterViewInit {
    constructor(
        private fetchDataService: FetchDataService,
        private eventService: EventService
    ) {
    }

    @Input() userManagement: boolean;
    @Output() userManagementChange: EventEmitter<boolean> = new EventEmitter<boolean>();
 
    submitError: boolean = false;
    errorMessage: string = "";
    //passwordPattern: string = "{6,20}$";
    passwordPatternDescription: string = "Password must be between 6 and 20 characters!";
    accessOptions: any;
    accessLookup: any;
    access: any[] = [];
    SMCPermission: any = [
        { value: this.fetchDataService.regular, alias: "Regular" },
        { value: this.fetchDataService.admin, alias: "Admin" },
        { value: this.fetchDataService.superAdmin, alias: "Super Admin" }
    ];
    RAMSPermission: any = [
        { value: this.fetchDataService.guest, alias: "Guest" },
        { value: this.fetchDataService.staff, alias: "Staff" },
        { value: this.fetchDataService.ramsAdmin, alias: "Admin" },
        { value: this.fetchDataService.siteAdmin, alias: "Site Admin" }
    ];
    SMCAdmin: boolean = false;
    RAMSAdmin: boolean = false;


    ngOnInit(): void {
        this.accessLookup = this.fetchDataService.getAccess();
        let access = this.accessLookup;
        this.SMCAdmin = this.fetchDataService.smcAdmin;
        this.RAMSAdmin = this.fetchDataService.cmAdmin;
        for (let accKey in access) {
            if (accKey !== this.fetchDataService._amsAccess && access[accKey])
                this.access.push({ name: accKey, access: !this.adminForBoth(), permission: this[accKey + "Permission"], admin: this[accKey + "Admin"] });
        }

    }

    ngAfterViewInit(): void {
        var inputs = $(".user-management-window-container").find('select, input, textarea, button, a').filter(':visible');
        var windowInputs = $(".user-management-body-container").find('select, input, textarea, button, a').filter(':visible');
        var firstInput = inputs.first();
        var lastInput = inputs.last();

        /*set focus on first input*/
        windowInputs.first().focus();

        /*redirect last tab to first input*/
        lastInput.on('keydown', function (e) {
            if ((e.which === 9 && !e.shiftKey)) {
                e.preventDefault();
                firstInput.focus();
            }
        });

        /*redirect first shift+tab to last input*/
        firstInput.on('keydown', function (e) {
            if ((e.which === 9 && e.shiftKey)) {
                e.preventDefault();
                lastInput.focus();
            }
        });

        $('input').attr('autocomplete', 'off');
        
    }

    setAccess(key: string): boolean {
        let bool;
        switch (key) {
            case "SMC": bool = this.RAMSAdmin && !this.SMCAdmin ? true : false; break;
            case "RAMS": bool = this.SMCAdmin && !this.RAMSAdmin ? false : false; break;
        }
        return bool;
    }

    close(): void {
        this.userManagement = false;
        this.userManagementChange.emit(this.userManagement);
    }

    confirmPassword(userInfo: any) {
        if (userInfo && userInfo.password && userInfo.confirmPassword) {
            if (userInfo.password !== userInfo.confirmPassword) {
                return "incorrect-password";
            }
            else {
                return "correct-password";
            }
        }
    }

    checkFormValid(formData: any) {
        if (!formData.valid) {
            return false;
        } else if (formData.value.password === formData.value.confirmPassword) {
            return false;
        } else if (this.accessOptions) {
            return false;
        } else {
            return true;
        }
    }

    displayError(formData: any) {
        if (formData.valid && formData.value.password !== formData.value.confirmPassword)
            this.errorMessage = "Passwords must match!";
        else
            this.errorMessage = "";
    }

    unfocusSelectElement() {
        $(".form-select").blur();
        //$("#form-submit-button").click();
    }

    adminForBoth(): boolean {
        return this.SMCAdmin && this.RAMSAdmin;
    }

    submitUser(userInfo: any): void {
        switch (null) {
            case userInfo.firstName: this.errorMessage = "First name not included!";
                break;
            case userInfo.lastName: this.errorMessage = "Last name not included!";
                break;
            //case userInfo.password: this.errorMessage = "Password not included!";
            //    break;
            case userInfo.email: this.errorMessage = "Email not included!";
                break;
            case userInfo.permission: this.errorMessage = "User permission not selected!";
                break;
            case userInfo.access: this.errorMessage = "User access not specified!";
                break;
            default: this.errorMessage = "";
        }
        if (!userInfo.SMCAccess && !userInfo.RAMSAccess) {
            this.errorMessage = "Please select at least one checkbox below!";
        }
        if (this.errorMessage) {
            this.submitError = true;
        } else {
            //let ref = this;
            //this.eventService.broadcast(this.eventService._showSpinner, "Submitting User...");
            //this.submitError = false;
            //this.fetchDataService.submitCreatedUser(new User(userInfo)).subscribe(
            //    (data) => {
            //        ref.fetchDataService.appendUser(userInfo);
            //        //ref.close();
            //    },
            //    (error) => {
            //        console.error(error);
            //        ref.eventService.broadcast(ref.eventService._closeSpinner);
            //        ref.eventService.broadcast(ref.eventService._displayModal, new ModalConfig(
            //            "alert",
            //            "Error",
            //            error,
            //            $(".user-management-body-container").find('select, input, textarea, button, a').filter(':visible').first(),
            //            () => { }
            //        ));
            //    },
            //    () => {
            //        ref.eventService.broadcast(ref.eventService._closeSpinner);
            //    });
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/create-user.component.ts